import React, { FC } from "react"
import { Link } from "react-router-dom"
import L10n from "lib/carrot-l10n"
import { MultiPathSVG } from "../SVG"
import { Header } from "components/views/atoms/Header"
import { H5 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type RequestCardHeaderProps = {
  backRoute: string
}

const RequestCardHeader: FC<RequestCardHeaderProps> = ({ backRoute }) => (
  <Header>
    <Link to={backRoute}>
      <MultiPathSVG className="dib mr2" iconName="icn-left-arrow" />
      <div className="dib">
        <H5>{l`[previous page]`}</H5>
      </div>
    </Link>
  </Header>
)

export default RequestCardHeader
